import { renderSchemaMarkdown } from "../../../extensions/json-schema/schema-markdown";

interface RequestPromptForm {
	Onboarding?: {
		Requests?: {
			Interface?: {
				Prompts?: {
					Submitted?: { Message?: unknown };
				};
			};
		};
	};
}

export function getSubmittedRequestMessage(
	form: RequestPromptForm | undefined,
	fallback: string,
	sanitize: (html: string) => string
): string {
	const message = form?.Onboarding?.Requests?.Interface?.Prompts?.Submitted?.Message;
	if(typeof message !== "string" || !message.trim()) {
		return fallback;
	}

	return `<div class="onboarding-submitted-message"><div class="schema-markdown">${renderSchemaMarkdown(message, sanitize)}</div></div>`;
}
